export default function Divider() {
  return <div className="mb-120 d-block w-100" style={{ minHeight: '1px' }}></div>;
}
